import { Flex, Heading } from '@radix-ui/themes';
import cx from 'classnames';
import React from 'react';
import styles from './PanelWrapper.module.css';

interface PanelWrapperProps {
  children: React.ReactNode;
  overflow?: boolean;
  title?: string;
}

// TODO: Deprecete use of this of composable approach
export default function PanelWrapper({
  children,
  overflow,
  title,
}: PanelWrapperProps): JSX.Element {
  return (
    <Flex px="6" py="4" direction="column" width="100%" className={styles.PanelWrapper}>
      {title ? (
        <Heading as="h2" weight="regular" size="5" mb="1">
          {title}
        </Heading>
      ) : null}
      <div className={cx(overflow && 'overflow-auto max-h-[26.50rem]')}>{children}</div>
    </Flex>
  );
}
